import React from 'react';

const SCRIPTURES = [
  {
    verse: '"Cada uno dé como propuso en su corazón; no con tristeza, ni por necesidad, porque Dios ama al dador alegre."',
    ref: '2 Corintios 9:7',
  },
  {
    verse: '"Honra a Jehová con tus bienes, y con las primicias de todos tus frutos; y serán llenos tus graneros con abundancia, y tus lagares rebosarán de mosto."',
    ref: 'Proverbios 3:9-10',
  },
  {
    verse: '"Dad, y se os dará; medida buena, apretada, remecida y rebosando darán en vuestro regazo; porque con la misma medida con que medís, os volverán a medir."',
    ref: 'Lucas 6:38',
  },
];

const TAX_BENEFITS = [
  {
    icon: '📄',
    title: 'Deducción de Impuestos',
    desc: 'Como organización 501(c)(3), tus donaciones son deducibles de impuestos según la ley federal.',
  },
  {
    icon: '🧾',
    title: 'Recibo Automático',
    desc: 'Recibes un recibo por correo electrónico después de cada donación para tus registros fiscales.',
  },
  {
    icon: '📊',
    title: 'Carta Anual',
    desc: 'Al final del año te enviamos un resumen de todas tus donaciones para presentar con tus impuestos.',
  },
];

export default function GivingLanding({ navigate }) {
  return (
    <>
      {/* Hero */}
      <div style={{
        background: 'linear-gradient(160deg, var(--navy-dark) 0%, var(--navy) 60%, #2a4080 100%)',
        borderRadius: 'var(--radius)',
        padding: '20px 20px',
        textAlign: 'center',
        color: 'white',
        marginBottom: 16,
        boxShadow: 'var(--shadow-lg)',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
          <div style={{ textAlign: 'left' }}>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 900, color: 'white', marginBottom: 4, letterSpacing: '-0.3px' }}>
              🙏 Diezmos y Ofrendas
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.82rem', lineHeight: 1.5 }}>
              Tu generosidad transforma vidas.
            </p>
          </div>
          <button
            onClick={() => navigate('give-form')}
            style={{
              background: 'var(--gold)',
              color: 'var(--navy)',
              border: 'none',
              borderRadius: 10,
              padding: '10px 20px',
              fontSize: '0.88rem',
              fontWeight: 800,
              cursor: 'pointer',
              fontFamily: 'Inter, sans-serif',
              whiteSpace: 'nowrap',
              boxShadow: '0 4px 16px rgba(201,168,76,0.35)',
              transition: 'all 0.2s',
            }}
          >
            💳 Dar Ahora
          </button>
        </div>
      </div>

      {/* Scripture Cards */}
      <div className="card">
        <h3 style={{ marginBottom: 16 }}>📖 Lo que Dice la Biblia</h3>
        {SCRIPTURES.map((s, i) => (
          <div key={i} style={{
            background: i % 2 === 0 ? '#f8f9ff' : '#fffbf0',
            borderRadius: 12,
            padding: '16px 18px',
            marginBottom: i < SCRIPTURES.length - 1 ? 12 : 0,
            borderLeft: `4px solid ${i % 2 === 0 ? 'var(--navy)' : 'var(--gold)'}`,
          }}>
            <p style={{ fontStyle: 'italic', color: '#444', fontSize: '0.9rem', lineHeight: 1.7, marginBottom: 6 }}>
              {s.verse}
            </p>
            <p style={{ fontWeight: 700, fontSize: '0.82rem', color: i % 2 === 0 ? 'var(--navy)' : '#b8932e' }}>
              — {s.ref}
            </p>
          </div>
        ))}
      </div>

      {/* Tax Benefits */}
      <div className="card">
        <h3 style={{ marginBottom: 4 }}>💼 Beneficios de Deducción Fiscal</h3>
        <p style={{ fontSize: '0.82rem', color: 'var(--text-sub)', marginBottom: 16 }}>
          Bethesda Español es una organización sin fines de lucro 501(c)(3) registrada.
        </p>
        {TAX_BENEFITS.map((b, i) => (
          <div key={i} style={{
            display: 'flex',
            gap: 14,
            alignItems: 'flex-start',
            padding: '12px 0',
            borderBottom: i < TAX_BENEFITS.length - 1 ? '1px solid var(--border)' : 'none',
          }}>
            <div style={{
              background: '#f0f2f7',
              borderRadius: 10,
              width: 44,
              height: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.3rem',
              flexShrink: 0,
            }}>
              {b.icon}
            </div>
            <div>
              <p style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--navy)', marginBottom: 3 }}>{b.title}</p>
              <p style={{ fontSize: '0.82rem', color: 'var(--text-sub)', lineHeight: 1.6 }}>{b.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom CTA */}
      <div style={{
        background: 'linear-gradient(135deg, #f0f2f7, #e8ecf5)',
        borderRadius: 'var(--radius)',
        padding: '24px',
        textAlign: 'center',
        marginBottom: 16,
        border: '1px solid var(--border)',
      }}>
        <p style={{ fontSize: '0.9rem', color: 'var(--text-sub)', marginBottom: 16, lineHeight: 1.6 }}>
          ¿Listo para dar? Tu donación llega directamente a nuestro ministerio de forma segura.
        </p>
        <button
          onClick={() => navigate('give-form')}
          style={{
            background: 'var(--navy)',
            color: 'white',
            border: 'none',
            borderRadius: 10,
            padding: '13px 32px',
            fontSize: '0.95rem',
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'Inter, sans-serif',
            width: '100%',
            transition: 'all 0.2s',
          }}
        >
          🙏 Ir a la Página de Donación
        </button>
        <p style={{ fontSize: '0.75rem', color: '#aaa', marginTop: 10 }}>
          🔒 Pagos seguros y encriptados
        </p>
        <button
          onClick={() => navigate('privacy-policy')}
          style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '0.75rem', cursor: 'pointer', textDecoration: 'underline', marginTop: 6 }}
        >
          Política de Privacidad
        </button>
      </div>
    </>
  );
}
